"use client";

import React from "react";
import { CalendarClock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const countdownBlocks = [];
export default function ReadyForTaxSeason() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.2
  });
  const {
    ref: countdownRef,
    isVisible: countdownVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="232359" id="únete-a-la-academia" ref={sectionRef} className="bg-primary text-primary-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "linear-gradient(135deg, hsl(243 75% 45% / 0.4) 0%, hsl(243 75% 59% / 0.0) 50%, hsl(243 75% 35% / 0.4) 100%)"
    }} />

      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] pointer-events-none opacity-30 blur-3xl" style={{
      background: "radial-gradient(ellipse at center, white 0%, transparent 70%)"
    }} />

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 md:py-28 flex flex-col items-center text-center gap-10">

        {}
        <div className={`transition-all duration-700 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="inline-flex items-center gap-2 uppercase tracking-widest px-4 py-2 rounded-md border !font-extrabold !font-sans !text-2xl" style={{
          color: "white",
          borderColor: "rgba(255,255,255,0.3)",
          background: "rgba(255,255,255,0.1)"
        }}>ABIERTA MATRICULA PARA CURSO 2026 / 2027</span>
        </div>

        {}
        <div className={`transition-all duration-700 delay-150 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight" style={{
          color: "white"
        }}>
            ¿Listo para empezar tu{" "}
            <span className="relative inline-block" style={{
            color: "white"
          }}>formación?<span className="absolute -bottom-1 left-0 w-full h-0.5 rounded-lg" data-ast-id="f:/src/pages/Home/sections/ReadyForTaxSeason.tsx|sig:3r49ja" data-ast-start="2297" data-ast-end="2425" style={{
              background: 'white'
            }}></span></span>
          </h2>
          <p className="mt-5 max-w-xl mx-auto leading-relaxed opacity-90 !font-extrabold !font-sans !text-2xl" style={{
          color: "white"
        }}>Transforma tu futuro con una formación diseñada para el éxito. Únete a CENTRO COSMOS y supera tus asignaturas con facilidad</p>
        </div>

        {}
        <div ref={countdownRef} className={`w-full max-w-xl transition-all duration-700 delay-300 ${countdownVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="grid grid-cols-4 gap-3 md:gap-4">
            {countdownBlocks.map((block, i) => <div data-index={i} key={block.label} className="flex flex-col items-center gap-1.5 rounded-lg px-3 py-4 border" style={{
            background: "rgba(255, 255, 255, 0.1)",
            borderColor: "rgba(255, 255, 255, 0.2)",
            backdropFilter: "blur(8px)"
          }}>
                <span className="font-default text-3xl md:text-4xl font-bold tabular-nums" style={{
              color: "white"
            }}>
                  {block.value}
                </span>
                <span className="text-xs uppercase tracking-widest font-mono" style={{
              color: "rgba(255, 255, 255, 0.7)"
            }}>
                  {block.label}
                </span>
              </div>)}
          </div>
          
        </div>

        {}
        <div className="w-16 h-px rounded-lg" style={{
        background: "white"
      }} />

        {}
        <div className={`transition-all duration-700 delay-500 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Button asChild size="lg" className="text-sm font-medium inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive has-[>svg]:px-4 px-8 py-6 h-auto shadow-lg transition-all !font-sans !font-extrabold !text-2xl disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:shadow-xl hover:scale-105 text-muted-foreground bg-muted-foreground rounded-none" style={{
          background: "white",
          color: "var(--primary)"
        }}>
            <Link to="/CoursesPage">Inscríbete en la Academia</Link>
          </Button>
          <p className="mt-4 text-xs font-default" style={{
          color: "rgba(255, 255, 255, 0.7)"
        }}><br /></p>
        </div>
      </div>
    </section>;
}